export const trusteeEn = ["O. M. C. Neelakandan Namboothiripad","G. P. Priyadath","O. M. Vasudevan","O. M. Ajayakumar","O. M. Hari","O. V. Narayanan","Bindu, P. K.","O. M. Rakesh","M. D. Mani","K. P. Balan Namboothiri","R. S. Ashok Kumar","C. A. Baiju","K. M. Pradeep"];

export const extra = {
  en: {
    story: {
      title: "Living together, serving together",
      text: "Our guiding principle is “Living Together and Engaging in Humanitarian Service.” We walk beside palliative care patients and their families, so no one in Mundur and Kongad faces illness alone.",
      points: ["Formed in 2022 at the special initiative of Sri O.M.C. Neelakandan Namboothiripad", "Works with palliative care centres, health institutions and doctors in Kongad and Mundur", "Runs on public donations and the trust's own funds"],
    },
    equipHome: { title: "Equipment that changes a home", sub: "Each item is given to a patient who cannot afford it. You can sponsor one.", sponsor: "Sponsor this" },
    equipDesc: [
      "Gives steady oxygen at home to patients who struggle to breathe.",
      "Helps patients with limited movement get around.",
      "Eases pressure on the body of long-term bedridden patients.",
      "Adjustable bed that makes nursing care at home easier.",
      "Supplies for a patient's dialysis session.",
      "Gives support to patients who can walk with help.",
    ],
    journal: {
      title: "Our work, moment by moment", sub: "From our first inauguration to our latest outreach.",
      tabs: ["Milestones", "Food, study & homes", "Medical & palliative care", "Community & travel"],
      items: [
        ["Inauguration of the Olappamanna Charitable Trust.", "Inauguration of the Olappamanna Charitable Trust building in 2024.", "Second Anniversary Celebration of the Olappamanna Charitable Trust.", "Inauguration of the second anniversary celebrations and palliative care service activities."],
        ["Distribution of food kits to the trust's beneficiaries.", "Distribution of food kits.", "Distribution of study materials to students.", "House renovation assistance for needy families."],
        ["Medical assistance and health-related services.", "Support and assistance for palliative care patients.", "Medical camp and health check-up activities.", "Palliative care-related services and support.", "Donation of an oxygen concentrator to the trust.", "Provision of a palliative care mattress.", "Palliative care awareness and support programme in Mundur and Kongad."],
        ["Joint programme with the Lions Club, Kongad.", "Transportation assistance for palliative care patients.", "Recreational trip for palliative care patients.", "Organised transportation for patients to medical facilities."],
      ],
    },
    trustees: { title: "Our trustees", sub: "The people who guide the trust.", lead: "Special initiative behind the trust" },
    homeMore: {
      plansTitle: "Our care centres",
      plansSub: "Two projects we are working towards, with your help.",
      explore: "Explore",
      today: "What we do today",
      firstStep: "A first step",
      galleryTitle: "Moments from our work",
      gallerySub: "A glimpse of food kits, medical support and outings with our patients.",
      galleryLink: "View full gallery",
    },
  },
  ml: {
    story: {
      title: "ഒരുമിച്ച് ജീവിച്ച്, ഒരുമിച്ച് സേവിച്ച്",
      text: "“ഒരുമിച്ച് ജീവിക്കുക, മാനവസേവനത്തിൽ ഏർപ്പെടുക” എന്നതാണ് ഞങ്ങളുടെ തത്വം. മുണ്ടൂരിലും കോങ്ങാടും ആരും രോഗത്തെ ഒറ്റയ്ക്ക് നേരിടേണ്ടി വരാതിരിക്കാൻ പാലിയേറ്റീവ് രോഗികൾക്കും കുടുംബങ്ങൾക്കും ഒപ്പം ഞങ്ങൾ നിൽക്കുന്നു.",
      points: ["ശ്രീ ഒ.എം.സി. നീലകണ്ഠൻ നമ്പൂതിരിപ്പാടിന്റെ പ്രത്യേക മുൻകൈയിൽ 2022-ൽ രൂപീകരിച്ചു", "കോങ്ങാട്, മുണ്ടൂർ പ്രദേശങ്ങളിലെ പാലിയേറ്റീവ് കേന്ദ്രങ്ങൾ, ആരോഗ്യ സ്ഥാപനങ്ങൾ, ഡോക്ടർമാർ എന്നിവരുമായി സഹകരിക്കുന്നു", "പൊതുസംഭാവനകളും ട്രസ്റ്റ് ഫണ്ടും കൊണ്ട് പ്രവർത്തിക്കുന്നു"],
    },
    equipHome: { title: "ഒരു വീടിനെ മാറ്റുന്ന ഉപകരണങ്ങൾ", sub: "വാങ്ങാൻ കഴിയാത്ത രോഗികൾക്കാണ് ഓരോന്നും നൽകുന്നത്. ഒരെണ്ണം നിങ്ങൾക്കും സ്പോൺസർ ചെയ്യാം.", sponsor: "സ്പോൺസർ ചെയ്യൂ" },
    equipDesc: [
      "ശ്വസിക്കാൻ പ്രയാസമുള്ള രോഗികൾക്ക് വീട്ടിൽ തുടർച്ചയായി ഓക്സിജൻ ലഭ്യമാക്കുന്നു.",
      "ചലനശേഷി കുറഞ്ഞ രോഗികൾക്ക് സഞ്ചരിക്കാൻ സഹായിക്കുന്നു.",
      "ദീർഘകാലം കിടപ്പിലായ രോഗികളുടെ ശരീരത്തിലെ സമ്മർദ്ദം കുറയ്ക്കുന്നു.",
      "വീട്ടിലെ പരിചരണം എളുപ്പമാക്കുന്ന ക്രമീകരിക്കാവുന്ന കട്ടിൽ.",
      "രോഗിയുടെ ഡയാലിസിസിന് ആവശ്യമായ സാമഗ്രികൾ.",
      "സഹായത്തോടെ നടക്കാൻ കഴിയുന്ന രോഗികൾക്ക് താങ്ങ് നൽകുന്നു.",
    ],
    journal: {
      title: "ഞങ്ങളുടെ പ്രവർത്തനം, നിമിഷം നിമിഷമായി", sub: "ആദ്യ ഉദ്ഘാടനം മുതൽ ഏറ്റവും പുതിയ സേവനം വരെ.",
      tabs: ["നാഴികക്കല്ലുകൾ", "ഭക്ഷണം, പഠനം, വീട്", "വൈദ്യവും പാലിയേറ്റീവും", "സമൂഹവും യാത്രയും"],
      items: [
        ["ഒളപ്പമണ്ണ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെ ഉദ്ഘാടനം.", "2024-ൽ ഒളപ്പമണ്ണ ചാരിറ്റബിൾ ട്രസ്റ്റ് കെട്ടിടത്തിന്റെ ഉദ്ഘാടനം.", "ഒളപ്പമണ്ണ ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെ രണ്ടാം വാർഷികാഘോഷം.", "രണ്ടാം വാർഷികാഘോഷത്തിന്റെയും പാലിയേറ്റീവ് സേവന പ്രവർത്തനങ്ങളുടെയും ഉദ്ഘാടനം."],
        ["ട്രസ്റ്റിന്റെ ഗുണഭോക്താക്കൾക്ക് ഭക്ഷ്യക്കിറ്റ് വിതരണം.", "ഭക്ഷ്യക്കിറ്റ് വിതരണം.", "വിദ്യാർഥികൾക്ക് പഠനസാമഗ്രികളുടെ വിതരണം.", "അർഹരായ കുടുംബങ്ങൾക്ക് വീട് നവീകരണ സഹായം."],
        ["വൈദ്യസഹായവും ആരോഗ്യസംബന്ധമായ സേവനങ്ങളും.", "പാലിയേറ്റീവ് രോഗികൾക്ക് പിന്തുണയും സഹായവും.", "മെഡിക്കൽ ക്യാമ്പും ആരോഗ്യ പരിശോധനയും.", "പാലിയേറ്റീവ് പരിചരണ സേവനങ്ങളും പിന്തുണയും.", "ട്രസ്റ്റിന് ഓക്സിജൻ കോൺസെൻട്രേറ്റർ സംഭാവന.", "പാലിയേറ്റീവ് മെത്ത നൽകൽ.", "മുണ്ടൂർ, കോങ്ങാട് പ്രദേശങ്ങളിൽ പാലിയേറ്റീവ് ബോധവൽക്കരണ-പിന്തുണാ പരിപാടി."],
        ["കോങ്ങാട് ലയൺസ് ക്ലബ്ബുമായി ചേർന്നുള്ള സംയുക്ത പരിപാടി.", "പാലിയേറ്റീവ് രോഗികൾക്ക് യാത്രാസഹായം.", "പാലിയേറ്റീവ് രോഗികൾക്കായുള്ള വിനോദയാത്ര.", "രോഗികളെ ആശുപത്രികളിലെത്തിക്കാൻ യാത്രാസൗകര്യം ഒരുക്കൽ."],
      ],
    },
    trustees: {
      title: "ഞങ്ങളുടെ ട്രസ്റ്റി അംഗങ്ങൾ", sub: "ട്രസ്റ്റിനെ നയിക്കുന്നവർ.", lead: "ട്രസ്റ്റിന് പിന്നിലെ പ്രത്യേക മുൻകൈ",
      names: ["ഒ.എം.സി. നീലകണ്ഠൻ നമ്പൂതിരിപ്പാട്","ജി.പി. പ്രിയദത്ത്","ഒ.എം. വാസുദേവൻ","ഒ.എം. അജയകുമാർ","ഒ.എം. ഹരി","ഒ.വി. നാരായണൻ","ബിന്ദു പി.കെ.","ഒ.എം. രാകേഷ്","എം.ഡി. മണി","കെ.പി. ബാലൻ നമ്പൂതിരി","ആർ.എസ്. അശോക് കുമാർ","സി.എ. ബൈജു","കെ.എം. പ്രദീപ്"],
    },
    homeMore: {
      plansTitle: "ഞങ്ങളുടെ പരിചരണ കേന്ദ്രങ്ങൾ",
      plansSub: "നിങ്ങളുടെ സഹായത്തോടെ ഞങ്ങൾ ലക്ഷ്യമിടുന്ന രണ്ട് പദ്ധതികൾ.",
      explore: "കൂടുതൽ അറിയാം",
      today: "ഇപ്പോൾ ചെയ്യുന്നത്",
      firstStep: "ആദ്യ ചുവട്",
      galleryTitle: "ഞങ്ങളുടെ പ്രവർത്തനങ്ങളിലെ നിമിഷങ്ങൾ",
      gallerySub: "ഭക്ഷ്യക്കിറ്റ്, വൈദ്യസഹായം, രോഗികളോടൊപ്പമുള്ള യാത്രകൾ എന്നിവയുടെ ഒരു നേർക്കാഴ്ച.",
      galleryLink: "ഗാലറി മുഴുവൻ കാണുക",
    },
  },
};
extra.en.trustees.names = trusteeEn;